<template>
  <header class="login">
    <div style="margin: 0 auto;" @click="userName=''">
      <img src="../../assets/img/logo.png" style="width: 100%;height: 220px; max-width: 518px;"/>
    </div>

    <div class>

      <!-- 输入手机号，调起手机号键盘 -->
      <van-field v-model="phone" type="tel" label="手机号" />

      <!-- 输入任意文本 -->
      <van-field v-model="truename" label="姓名" />

      <!-- 登录 -->
      <button @click="login" class="butt ml-20 mr-20 fff">绑定</button>
    </div>

    <div style="width:100%; height: 30px;color:#000;text-align:center;position: fixed;bottom: 0px;width:100%;background-color: #fff; padding: 5px;">
      <a href="http://beian.miit.gov.cn">苏ICP备2025181147号-1</a>
    </div>

  </header>
</template>

<script>
import { constants } from "crypto";
import Vue from 'vue';
import { Toast,Image as VanImage } from 'vant';
import axios from 'axios'

Vue.use(VanImage);
export default {
  data() {
    return {
      phone: "",
      truename:'',
        code:''
    };
  },
    created(){
        this.code = this.getUrlCode().code;
    },
  methods: {
      getUrlCode() { // 截取url中的code方法
          var url = location.search
          this.winUrl = url
          var theRequest = new Object()
          if (url.indexOf("?") != -1) {
              var str = url.substr(1)
              var strs = str.split("&")
              for(var i = 0; i < strs.length; i ++) {
                  theRequest[strs[i].split("=")[0]]=(strs[i].split("=")[1])
              }
          }
          return theRequest
      },
    login() {
      if(this.truename == '' || this.phone == '') {
        Toast.fail('请输入手机号与姓名');
        return;
      }

      if(!(/^1(3|4|5|6|7|8|9)\d{9}$/.test(this.phone))){
        Toast.fail('手机号码格式有误，请重新输入');
        return;
      }

      var _that = this;

        const postLoading = Toast.loading({
            duration: 0, // 持续展示 toast
            forbidClick: true,
            message: '绑定中...',
        });

        axios.post(window.config.apiUrl + '/api/Public/BindUser', {
            "OpenId": _that.code,
            "MobilePhone": _that.phone,
            "TrueName": _that.truename
        })
            .then(function (response) {
                postLoading.clear();
                let recvData = response.data;
                if(recvData.code == 1) {
                    Toast("绑定成功");
                } else {
                  Toast.fail(recvData.msg);
                }
            })
            .catch(function (error) {
                postLoading.clear();
                Toast(error);
            })
    },
    UrlEncode(str) {
      var ret = "";
      var strSpecial = "!\"#$%&'()*+,/:;<=>?[]^`{|}~%";
      var tt = "";
      for (var i = 0; i < str.length; i++) {
          var chr = str.charAt(i);
          var c = this.str2asc(chr);
          tt += chr + ":" + c + "n";
          if (parseInt("0x" + c) > 0x7f) {
              ret += "%" + c.slice(0, 2) + "%" + c.slice(-2);
          } else {
              if (chr == " ")
                  ret += "+";
              else if (strSpecial.indexOf(chr) != -1)
                  ret += "%" + c.toString(16);
              else
                  ret += chr;
          }
      }
      return ret;
    },
    str2asc(strstr) {
      return ("0" + strstr.charCodeAt(0).toString(16)).slice(-2);
    }
  }
};
</script>

<style lang="less" scoped>
@import "./login.less";
.logo {
  font-size: 100px !important;
  margin-bottom: 150px;
}
</style>

